import { IAppState } from '../../redux';
import { EPlacingType } from '../../redux/reducers';

export function selectActivePlacingType(state: IAppState): EPlacingType | null {
  return state.publishTerms.selectedPlacingType;
}
